<template>
    <div>
        <div class="header-return">
            <el-row>
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
                    <el-form-item label="">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <!--<el-table-column label="标识" prop="activeIndexId" width="80"></el-table-column>-->
            <el-table-column label="来源" prop="activeName" width="190"></el-table-column>
            <el-table-column label="填写时间" prop="createTime" width="230"></el-table-column>
            <el-table-column label="昵称" prop="nickName" width="180"></el-table-column>
            <el-table-column label="地区" prop="activeUrl" width="350">
                <template slot-scope="scope">
                    {{scope.row.province}}-{{scope.row.city}}
                </template>
            </el-table-column>
            <el-table-column label="等级" prop="level" width="100"></el-table-column>
            <el-table-column label="关注时间" prop="subscribeTime" width="100"></el-table-column>
            <el-table-column label="首单时间" prop="firstOrderTime" width="100"></el-table-column>
            <el-table-column label="累计订单数" prop="orderNum" width="100"></el-table-column>
            <el-table-column label="累计购买金额" prop="totalAmount" width="100"></el-table-column>
            <el-table-column label="最近购买时间" prop="lastBuyTime" width="100"></el-table-column>
            <el-table-column label="最近订单物流类型" prop="transportType" width="100"></el-table-column>
            <el-table-column label="最近购买商品类目" prop="productCategory" width="100"></el-table-column>
            <el-table-column label="评分" prop="score" width="100"></el-table-column>
            <el-table-column label="反馈"  prop="feedBack" ></el-table-column>
            <el-table-column label="操作" fixed="right" >
                <template slot-scope="scope">
                    <el-button type="primary" v-show="scope.row.answerList.length>0" size="mini" @click="getDetail(scope.row)">查看反馈详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="反馈详情" :visible.sync="showDialog">
            <el-table :data="answerItemList" stripe border center :size="GCONFIG.styleTableSize">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="反馈"  prop="name" fixed="right" ></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getNpsList
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    export default {
        data() {
            return {
                showDialog: false,
                list: [],
                recordsTotal:0,
                formInline: {
                    currentPage: 1,
                    pageSize: 20
                },
                answerItemList:[],
                loading: true,
                activeList:[]
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                getNpsList(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;

                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            getDetail(row){
                this.showDialog=true;
                this.answerItemList=[];
                row.answerList.forEach(answerItem=> {
                    let answer={};
                    answer.name=answerItem;
                    this.answerItemList.push(answer);
                })
            },
            formatDate(datetime) {
                if(datetime==null){
                    return '';
                }else {
                    var date = new Date(datetime);
                    var year = date.getFullYear(),
                        month = ("0" + (date.getMonth() + 1)).slice(-2),
                        sdate = ("0" + date.getDate()).slice(-2),
                        hour = ("0" + date.getHours()).slice(-2),
                        minute = ("0" + date.getMinutes()).slice(-2),
                        second = ("0" + date.getSeconds()).slice(-2);
                    // 拼接
                    var result = year + "-"+ month +"-"+ sdate +" "+ hour +":"+ minute +":" + second;
                    // 返回
                    return result;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/active/nps.vue